"use client";
import Account from "@/assets/svg/24/Account";
import Link from "next/link";
import styles from "../header.module.css";

const ClientAccountTrigger = () => {
  return (
    <Link href={"/konto"} className={`${styles.icon} ${styles.favourites}`}>
      <Account />
    </Link>
  );
};

export default ClientAccountTrigger;
